
import utils from '../../utils/utils'
let apiURL = '';

if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL =  'http://proxy.jiankanghao.net:50245'
  // apiURL = 'https://kane.haiweikexin.com'
  //apiURL = 'http://192.168.0.70:8080'
}else {
  apiURL =   utils.decrypt(document.querySelector("html").getAttribute("api_h5_url"))
}
// utils.decrypt(document.querySelector("html").getAttribute("api_h5_url"))
export default apiURL;
